<div *ngIf="isLoading" class="spinner">
  <div class="lds-ring-xl"></div>
</div>

<div *ngIf="!isLoading && !homeKustomer" class="home">
  <img class="logo-text" src="./assets/img/rappi-logo.svg" alt="logo" />
  <br />
  <img class="logo" src="./assets/img/rappi-circle-logo.svg" alt="logo" />
  <h1 class="mt-md title">Turbo WMS</h1>
  <h3 class="subtitle">
    {{ subTitle }}
  </h3>
</div>

<div *ngIf="!isLoading && homeKustomer" id="home-kustomer">
  <div *ngIf="!displayExternal" class="title">
    <h1>{{ title }}</h1>
  </div>

  <div *ngIf="!displayExternal" class="container-card">
    <div *ngFor="let card of cards" class="card">
      <div class="img">
        <img src="{{ card.ROUTE }}" alt="" />
      </div>
      <div class="card-title">{{ card.TITLE }}</div>
      <div class="card-description">{{ card.DESCRIPTION }}</div>
      <div class="card-navigate">
        <button (click)="handleNavigate(card.URLEXTERNAL, card.TITLE)">
          {{ card.NAVIGATEBUTTON }}
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="displayExternal" class="card-detail">
    <div class="card-detail-breadcrumb">
      <img src="./assets/img/turbo-back.svg" alt="arrow-back" />
      <a (click)="handleBackCards()">Volver</a>
      <span>Home | {{ breadcrumbTitle }}</span>
    </div>

    <div class="card-detail-body">
      <iframe
        *ngIf="displayExternal"
        [src]="iframeSrc"
        sandbox="allow-scripts"
        width="100%"
        height="800"
      >
      </iframe>
    </div>
  </div>
</div>
